// extracted by mini-css-extract-plugin
module.exports = {"table":"ReportList_table_33XXp","name":"ReportList_name_2rO32"};